﻿import { useContext } from 'react';
import { getContext } from 'helpers/context';

const UserContext = getContext('ClearConnection.Client.UserContext');

export default function useLoggedInUser() {
  const { user } = useContext(UserContext);
  return user;
}
